import React, { ReactElement } from "react";
import { FaSpinner } from "react-icons/fa";
import Styles from "./Loading.module.scss";

export function LoadingIcon({ className, size }: {className?: string; size?: string}): ReactElement {
    return (
        <FaSpinner className={`text-light ${Styles.spinner} ${className}`} size={size} />
        // <FontAwesomeIcon icon={faSpinner} size="4x" pulse spin className="text-light" width="100px" />
    );
}
LoadingIcon.defaultProps = {
    className: "",
    size: "100px",
};

export default function Loading(): ReactElement {
    return (
        <div data-testid="loading" className="vh-100 d-flex align-items-center justify-content-center">
            <LoadingIcon />
        </div>
    );
}
